<template>
  <div class="page">
    <Table
      :data="data"
      ref="table"
      checkType="none"
      :resizable="true"
      :loading="loading"
    >
      <TableColumn title="名称" key="SQLName">
        <template slot-scope="item">
          <div v-if="item.SQLName.length < 20">{{ item.SQLName }}</div>
          <TableTooltip
            :content="item.SQLName"
            :contentLength="20"
            v-else
          ></TableTooltip>
        </template>
      </TableColumn>
      <TableColumn title="描述" key="comment">
        <template slot-scope="item">
          <div v-if="item.Comment.length < 20">{{ item.Comment }}</div>
          <TableTooltip
            :content="item.Comment"
            :contentLength="20"
            v-else
          ></TableTooltip>
        </template>
      </TableColumn>
      <TableColumn title="保存时间" key="CreateTime">
        <template slot="template" slot-scope="data">
          {{ data.CreateTime | datefmt("YYYY-MM-DD HH:mm:ss") }}
        </template>
      </TableColumn>
      <TableColumn title="操作" key="op" ignore>
        <template slot="template" slot-scope="data">
          <a><span class="c-mgr-10" @click="open(data)">打开</span></a>
          <a><span @click="confirm(data)">删除</span></a>
        </template>
      </TableColumn>
    </Table>
    <Pagination
      class="c-center c-m-t-15"
      :total="pageInfo.total"
      :limit.sync="pageInfo.limit"
      :limits="pageInfo.limits"
      :current="pageInfo.pageNum"
      ref="__test"
      @change="fetch"
    />
  </div>
</template>
<script>
import Pagination from 'kpc/components/pagination';
import { Table, TableColumn } from 'kpc/components/table';
import TableTooltip from '@/components/table-tooltip.vue';
import { requestSqlList, requestDelSql } from '@/apis/save-sql';
export default {
  components: {
    Table,
    TableColumn,
    TableTooltip,
    Pagination
  },
  data() {
    return {
      loading: false,
      data: [],
      pageInfo: {
        limit: 10,
        limits: [10, 20, 50, 100]
      }
    };
  },
  destroyed() {
    this.$EventBus.$off('REGION_CHANGED', this.updateRegion);
  },
  created() {
    this.fetch();
    this.$EventBus.$on('REGION_CHANGED', this.updateRegion);
  },
  methods: {
    async updateRegion() {
      this.fetch();
    },
    async fetch({ current = 1, limit = 10 } = {}) {
      //  this.Message.info('close after 10s', 1000000);
      let params = {
        PageSize: limit,
        CurrentPage: current
      };
      this.showLoading();
      try {
        let res = await requestSqlList(params);
        this.data = res.data.Data;
        if (res.data.Total) {
          this.pageInfo.total = res.data.Total.TotalRecords;
          this.pageInfo.pageNum = res.data.Total.CurrentPage;
          this.pageInfo.pageSize = res.data.Total.PageSize;
        }
      } catch (error) {
        this.Message['error'](` ${error.msg}`);
      }
      this.hideLoading();
    },
    open(e) {
      console.log('open,', e);
      const { href } = this.$router.resolve({
        name: 'qeQuery',
        // params: {
        //   id: e.SQLId
        // },
        query: {
          id: e.SQLId
        }
      });
      window.open(href, '_blank');
    },
    confirm(data) {
      console.log('data:', data);
      this.Dialog['confirm']({
        title: '您确认删除SQL么？',
        content: '提示：操作会删除保存的SQL'
      }).then(
        () => {
          this.del(data);
        },
        () => {}
      );
    },
    async del(data) {
      let { SQLId } = data;
      this.showLoading();
      try {
        await requestDelSql({ SQLId });
        this.Message['success']('操作成功');
        let pageInfo = this.pageInfo;
        if (this.data.length === 1 && pageInfo.total > 1) {
          this.fetch({ current: pageInfo.pageNum - 1, limit: pageInfo.limit });
        } else {
          this.fetch({ current: pageInfo.pageNum, limit: pageInfo.limit });
        }
      } catch (error) {
        this.Message['error'](` ${error.msg}`);
      }
      this.hideLoading();
    }
  }
};
</script>
<style lang="stylus" scoped>
.page
  min-height calc(100vh - 120px)
  background white
  padding-bottom 40px;
.k-label
    color #666
    font-size 12px
    display: inline-block
    font-weight: normal
    margin: 0
</style>
